import React, { Component } from 'react';

import formCss from './forms.css';
import css from './editable-textfield.css';

// Material UI Library
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationCheck from 'material-ui/svg-icons/navigation/check';

class EditableTextField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      saving: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.state.saving && this.props.value !== newProps.value) {
      this.setState({
        editMode: false,
        saving: false,
      });
    }
  }

  handleFocus = (e) => {
    e.preventDefault();
    this.setState({ editMode: true });
  };

  cancelEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ editMode: false });
    if (this.props.onCancelEdit && typeof this.props.onCancelEdit === 'function') {
      this.props.onCancelEdit();
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.saveValue(this._input.getValue());
    this.setState({ saving: true });
  };

  render() {
    return (
      <form
        onSubmit={this.handleSubmit}
        onTouchTap={this.handleFocus}
        className={css.root}
        style={this.props.style}
      >
       {this.state.editMode ?
         <div>
           <TextField
             id={`${this.props.name}-edit`}
             floatingLabelText={this.props.floatingLabelText}
             floatingLabelFixed={true}
             defaultValue={this.props.value}
             type={this.props.type}
             className={this.props.className || formCss.textField}
             fullWidth={this.props.fullWidth}
             disabled={this.state.saving}
             ref={(c) => this._input = c}
           />
           <IconButton
             onTouchTap={this.cancelEdit}
             className={css.cancelBtn}
             style={{ position: 'absolute' }}
           >
             <NavigationClose />
           </IconButton>
          </div>
         :
         <TextField
           id={`${this.props.name}`}
           floatingLabelText={this.props.floatingLabelText}
           floatingLabelFixed={true}
           value={this.props.value || ''}
           className={this.props.className || formCss.textField}
           fullWidth={this.props.fullWidth}
           disabled={true}
         />
       }
      </form>
    );
  }
}

export default EditableTextField;



/** WEBPACK FOOTER **
 ** ./components/forms/EditableTextField.js
 **/